import { isUnavailableToken as coreIsUnavailableToken } from '@/utils/responseGuard'

const TECHNICAL_UNAVAILABLE_TOKENS = [
  'technicalerror',
  'technical_error',
  'technical error',
  'technical-error',
  'technicalexception',
  'technical_exception',
  'technical exception',
  'technical-exception',
  'technicalmarker',
  'technical_marker',
  'technical marker',
  'technical-marker',
  'backendfailure',
  'backend_failure',
  'backend failure',
  'backend-failure',
  'missingtable',
  'missing_table',
  'missing table',
  'missing-table',
  'missingcolumn',
  'missing_column',
  'missing column',
  'missing-column'
]

const TECHNICAL_MARKER_KEYS = [
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'technicalMarker',
  'technical_marker',
  'backendFailure',
  'backend_failure',
  'missingTable',
  'missing_table',
  'missingColumn',
  'missing_column'
]

const FAILURE_TOKENS = [
  '0',
  'false',
  'fail',
  'failed',
  'failure',
  'failclosed',
  'fail_closed',
  'fail-closed',
  'fail closed',
  'falseproof',
  'false_proof',
  'false-proof',
  'false proof',
  'error',
  'rejected',
  'locked',
  'blocked',
  'fallback',
  'fallback_used',
  'fallback used',
  'dataunavailable',
  'data_unavailable',
  'data unavailable',
  'readfailure',
  'read_failure',
  'read failure',
  'read-failure',
  'read_blocked',
  'readblocked',
  'read blocked',
  'read-blocked',
  'readunavailable',
  'read_unavailable',
  'read unavailable',
  'read-unavailable',
  'routeunavailable',
  'route_unavailable',
  'route unavailable',
  'route-unavailable',
  'not_receive',
  'not_received',
  'not_available',
  'unavailable',
  'mock',
  'mock_mode',
  'mock mode',
  'mock-mode',
  'mock_fallback',
  'mock-fallback',
  'mock fallback',
  'disabled',
  'stub',
  'read_only',
  'read_only_mode',
  'read only mode',
  'read-only-mode',
  'read_only_reward',
  'readonlyreward',
  'read only reward',
  'read-only-reward',
  'read_only_action',
  'readonlyaction',
  'read only action',
  'read-only-action',
  'readonly',
  'readonlymode',
  'read only',
  'read-only',
  'unimplemented',
  'not_implemented',
  'notimplemented',
  'not implemented',
  'not_supported',
  'not-supported',
  'not supported',
  'not_connected',
  'not-connected',
  'not connected',
  'write_blocked',
  'writeblocked',
  'write blocked',
  'write-blocked',
  'backend_blocked',
  'backendblocked',
  'backend blocked',
  'backend-blocked',
  'backend_failure',
  'backendfailure',
  'backend failure',
  'backend-failure',
  'reward_backend_blocked',
  'rewardbackendblocked',
  'reward backend blocked',
  'reward-backend-blocked',
  'payment_backend_blocked',
  'paymentbackendblocked',
  'payment backend blocked',
  'payment-backend-blocked',
  'payment_status_unconfirmed',
  'paymentstatusunconfirmed',
  'payment status unconfirmed',
  'payment-status-unconfirmed',
  ...TECHNICAL_UNAVAILABLE_TOKENS,
  'unsupported'
]

const SUCCESS_TOKENS = [
  '1',
  'true',
  'success',
  'succeeded',
  'ok',
  'claimed',
  'received',
  'completed'
]

// UNAVAILABLE_TOKENS 已删除 —— 主 token 分类走 responseGuard 核 union(FAILURE/SUCCESS/TECHNICAL_UNAVAILABLE_TOKENS 领奖专属保留)

const RESPONSE_BODY_KEYS = [
  'list',
  'dataList',
  'signList',
  'records',
  'promoRuleList',
  'ruleList',
  'activityList',
  'newbie',
  'daily',
  'weekly',
  'points',
  'totalPoints',
  'milestones',
  'tasks',
  'rewards',
  'price',
  'totalValue',
  'countdownSeconds',
  'visible',
  'show',
  'active',
  'enabled',
  'readOnly',
  'readOnlyMode',
  'readOnlyReward',
  'read_only_mode',
  'read_only_reward',
  'readOnlyQuery',
  'read_only_query',
  'readOnlyAction',
  'read_only_action',
  'writeBlocked',
  'write_blocked',
  'backendBlocked',
  'backend_blocked',
  'backendFailure',
  'backend_failure',
  'rewardBackendBlocked',
  'reward_backend_blocked',
  'paymentBackendBlocked',
  'payment_backend_blocked',
  'paymentStatusUnconfirmed',
  'payment_status_unconfirmed',
  'notConnected',
  'not_connected',
  'dataUnavailable',
  'data_unavailable',
  'readFailure',
  'read_failure',
  'readBlocked',
  'read_blocked',
  'readUnavailable',
  'read_unavailable',
  'routeUnavailable',
  'route_unavailable',
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'technicalMarker',
  'technical_marker',
  'backendFailure',
  'backend_failure',
  'missingTable',
  'missing_table',
  'missingColumn',
  'missing_column',
  'falseProof',
  'false_proof',
  'fallbackSource',
  'fallback_source',
  'failClosed',
  'fail_closed',
  'localFallback',
  'local_fallback',
  'rewardProof',
  'reward_proof',
  'serverProof',
  'server_proof',
  'serverRewardProof',
  'server_reward_proof',
  'rewardIssued',
  'reward_issued',
  'affectedProof',
  'affected_proof',
  'writeProof',
  'write_proof',
  'serverCanClaim',
  'server_can_claim',
  'rewardWritable'
]
const ENVELOPE_KEYS = ['content', 'payload', 'extra', 'page', 'data', 'body']
const DIAGNOSTIC_ENVELOPE_KEYS = [
  'meta',
  'trace',
  'diagnostics',
  'diagnostic',
  'error',
  'errors',
  'detail',
  'details'
]
const ALL_MARKER_ENVELOPE_KEYS = [...ENVELOPE_KEYS, ...DIAGNOSTIC_ENVELOPE_KEYS]
const RESPONSE_METADATA_KEYS = [
  'readOnly',
  'readOnlyMode',
  'readOnlyReward',
  'read_only_mode',
  'read_only_reward',
  'readOnlyQuery',
  'read_only_query',
  'readOnlyAction',
  'read_only_action',
  'writeBlocked',
  'write_blocked',
  'backendBlocked',
  'backend_blocked',
  'backendFailure',
  'backend_failure',
  'rewardBackendBlocked',
  'reward_backend_blocked',
  'paymentBackendBlocked',
  'payment_backend_blocked',
  'paymentStatusUnconfirmed',
  'payment_status_unconfirmed',
  'notConnected',
  'not_connected',
  'dataUnavailable',
  'data_unavailable',
  'readFailure',
  'read_failure',
  'readBlocked',
  'read_blocked',
  'readUnavailable',
  'read_unavailable',
  'routeUnavailable',
  'route_unavailable',
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'technicalMarker',
  'technical_marker',
  'backendFailure',
  'backend_failure',
  'missingTable',
  'missing_table',
  'missingColumn',
  'missing_column',
  'falseProof',
  'false_proof',
  'fallbackSource',
  'fallback_source',
  'failClosed',
  'fail_closed',
  'localFallback',
  'local_fallback',
  'rewardProof',
  'reward_proof',
  'serverProof',
  'server_proof',
  'serverRewardProof',
  'server_reward_proof',
  'rewardIssued',
  'reward_issued',
  'affectedProof',
  'affected_proof',
  'writeProof',
  'write_proof',
  'serverCanClaim',
  'server_can_claim',
  'rewardWritable'
]
const RESPONSE_MESSAGE_KEYS = ['msg', 'message', 'errorMsg', 'errorMessage', 'reason', 'desc', 'description', 'detail']
const DEEP_MARKER_KEYS = [
  'readOnlyReward',
  'read_only_reward',
  'readOnlyMode',
  'read_only_mode',
  'readOnlyAction',
  'read_only_action',
  'mockMode',
  'mock_mode',
  'backendBlocked',
  'backend_blocked',
  'backendFailure',
  'backend_failure',
  'paymentBackendBlocked',
  'payment_backend_blocked',
  'paymentStatusUnconfirmed',
  'payment_status_unconfirmed',
  'writeBlocked',
  'write_blocked',
  'dataUnavailable',
  'data_unavailable',
  'readFailure',
  'read_failure',
  'readBlocked',
  'read_blocked',
  'readUnavailable',
  'read_unavailable',
  'routeUnavailable',
  'route_unavailable',
  'technicalError',
  'technical_error',
  'technicalException',
  'technical_exception',
  'technicalMarker',
  'technical_marker',
  'backendFailure',
  'backend_failure',
  'falseProof',
  'false_proof',
  'fallbackSource',
  'fallback_source',
  'failClosed',
  'fail_closed',
  'localFallback',
  'local_fallback',
  'rewardProof',
  'reward_proof',
  'serverProof',
  'server_proof',
  'serverRewardProof',
  'server_reward_proof',
  'rewardIssued',
  'reward_issued',
  'affectedProof',
  'affected_proof',
  'writeProof',
  'write_proof',
  'serverCanClaim',
  'server_can_claim'
]

export function isNeedLogin(res) {
  const data = requestErrorPayload(res)
  const content = responseContent(data)
  const bodies = responseBodies(data)
  const sources = [data, content, ...bodies]
  return !!(data && [
    data.status,
    data.state,
    data.code,
    data.errorCode,
    content.status,
    content.state,
    content.code,
    content.errorCode,
    ...bodies.flatMap(body => [
      body.status,
      body.state,
      body.code,
      body.errorCode
    ])
  ].some(value => {
    return isNeedLoginMessage(value)
  }) || sources.some(source => source && typeof source === 'object' && [
    source.needLogin,
    source.need_login,
    source.loginRequired,
    source.login_required,
    source.requireLogin,
    source.require_login
  ].some(isActiveGuardFlag)) || needLoginMessageValues(data).some(isNeedLoginMessage))
}

function requestErrorPayload(error) {
  if (!error || typeof error !== 'object') return error
  if (error.response && typeof error.response === 'object') {
    if (error.response.data !== undefined) return error.response.data
    if (error.response.body !== undefined) return error.response.body
  }
  if (error.cause && typeof error.cause === 'object') {
    const causePayload = requestErrorPayload(error.cause)
    if (causePayload && causePayload !== error.cause) return causePayload
  }
  return error instanceof Error ? { message: error.message } : error
}

export function firstValue(...values) {
  return values.find(value => value !== undefined && value !== null && value !== '')
}

export function hasResponseContent(content) {
  return content &&
    typeof content === 'object' &&
    !Array.isArray(content) &&
    Object.keys(content).length > 0
}

export function responseContent(res) {
  if (!res || typeof res !== 'object') return {}
  return unwrapResponseContent(firstResponseContent(res))
}

function responseBodies(res) {
  return collectDeepMarkerBodies(res, 0, collectResponseBodies(res))
}

function diagnosticBodies(res) {
  const bodies = collectDiagnosticBodies(res)
  return bodies.reduce((out, body) => collectDeepMarkerBodies(body, 0, out), bodies)
}

function normalizeResponseBody(value) {
  if (Array.isArray(value)) return { list: value, dataList: value }
  return hasResponseContent(value) ? value : {}
}

function firstResponseContent(source) {
  if (Array.isArray(source)) return source
  if (!source || typeof source !== 'object') return null
  const candidates = []
  for (const key of ENVELOPE_KEYS) {
    const value = source[key]
    if (Array.isArray(value)) return value
    if (hasResponseContent(value)) candidates.push(value)
  }
  const populated = candidates.find(value => {
    const unwrapped = unwrapResponseContent(value)
    return hasMeaningfulResponseBody(unwrapped)
  })
  if (populated) return populated
  const fallback = candidates.find(value => {
    const unwrapped = unwrapResponseContent(value)
    return hasAnyResponseBodyKey(unwrapped)
  })
  if (fallback) return fallback
  if (candidates.length) {
    return candidates[0]
  }
  if (hasAnyResponseBodyKey(source)) return source
  return null
}

function hasAnyResponseBodyKey(body) {
  return hasResponseContent(body) &&
    RESPONSE_BODY_KEYS.some(key => Object.prototype.hasOwnProperty.call(body, key))
}

function hasMeaningfulResponseBody(body) {
  if (!hasResponseContent(body)) return false
  return RESPONSE_BODY_KEYS.some(key => {
    if (RESPONSE_METADATA_KEYS.includes(key)) return false
    return Object.prototype.hasOwnProperty.call(body, key) && hasMeaningfulResponseValue(body[key])
  })
}

function hasMeaningfulResponseValue(value) {
  if (Array.isArray(value)) return value.length > 0
  if (value && typeof value === 'object') return Object.keys(value).length > 0
  return value !== undefined && value !== null && value !== ''
}

function hasMeaningfulBodyForMetadata(body) {
  return hasMeaningfulResponseBody(body) || hasRewardContent(body)
}

function hasNestedMeaningfulResponseBody(source, depth = 0) {
  if (!source || typeof source !== 'object' || depth >= 5) return false
  for (const key of ENVELOPE_KEYS) {
    const value = source[key]
    if (!value || (typeof value !== 'object' && !Array.isArray(value))) continue
    const unwrapped = unwrapResponseContent(value, depth + 1)
    if (hasMeaningfulBodyForMetadata(unwrapped)) return true
    const body = normalizeResponseBody(value)
    if (hasMeaningfulBodyForMetadata(body) || hasNestedMeaningfulResponseBody(body, depth + 1)) return true
  }
  return false
}

function isMetadataOnlyMessageSource(source) {
  return hasResponseContent(source) &&
    !hasMeaningfulBodyForMetadata(source) &&
    hasNestedMeaningfulResponseBody(source)
}

function responseMessageValues(source) {
  if (!source || typeof source !== 'object') return []
  return RESPONSE_MESSAGE_KEYS.map(key => source[key])
}

function isNeedLoginMessage(value) {
  if (value == null || typeof value === 'object') return false
  const text = unavailableToken(value)
  if (!text) return false
  const compact = text.replace(/[\s_-]+/g, '')
  return compact.includes('needlogin') ||
    compact.includes('loginrequired') ||
    compact.includes('notauthorized') ||
    compact.includes('tokenexpired') ||
    compact.includes('expiredtoken') ||
    compact.includes('loginexpired') ||
    compact.includes('sessionexpired') ||
    /\bunauthorized\b/.test(text) ||
    /(^|[^\d])401([^\d]|$)/.test(text)
}

function needLoginMessage(fallback) {
  return isGenericFailureMessage(fallback) ? '需要登录后继续操作。' : 'Please log in to continue'
}

function isGenericFailureMessage(value, fallback) {
  const text = unavailableToken(value)
  if (!text) return false
  const fallbackText = unavailableToken(fallback)
  return isTechnicalFailureMessageText(value) ||
    text === 'request failed' ||
    text.startsWith('request failed ') ||
    text === 'network error' ||
    text.includes('network error') ||
    text === 'networkerror' ||
    text === 'error' ||
    text.startsWith('timeout ') ||
    text.includes(' timeout') ||
    text.includes('timeout of ') ||
    text.includes('exceeded') ||
    text.includes('econn') ||
    /^(typeerror|referenceerror)(:|\s)/.test(text) ||
    /(^|\n)\s*at\s+\S+/.test(String(value == null ? '' : value)) ||
    /<\/?[a-z][\s\S]*>/i.test(String(value == null ? '' : value)) ||
    /https?:\/\/\S+/i.test(String(value == null ? '' : value)) ||
    (!!fallbackText && text === fallbackText && isGenericFailureMessage(fallbackText))
}

function hasSpecificBackendFailureMessage(value, fallback) {
  return !!value &&
    typeof value !== 'object' &&
    !isOptimisticSuccessMessage(value) &&
    !isBareUnavailableMarkerMessage(value) &&
    !isGenericFailureMessage(value, fallback)
}

function isBareUnavailableMarkerMessage(value) {
  const token = unavailableToken(value)
  return [
    'readonlyreward',
    'read_only_reward',
    'read-only-reward',
    'read only reward',
    'readonlyaction',
    'read_only_action',
    'read-only-action',
    'read only action',
    'notimplemented',
    'not_implemented',
    'not implemented',
    'mockfallback',
    'mock_fallback',
    'mock-fallback',
    'mock fallback',
    'backendblocked',
    'backend_blocked',
    'backend-blocked',
    'backend blocked',
    'backendfailure',
    'backend_failure',
    'backend-failure',
    'backend failure',
    'writeblocked',
    'write_blocked',
    'write-blocked',
    'write blocked',
    ...TECHNICAL_UNAVAILABLE_TOKENS
  ].includes(token)
}

function failureFallbackMessage(fallback, message) {
  return isGenericFailureMessage(fallback) ? message : fallback || message
}

function blockingResponseMessages(sources) {
  return sources.flatMap(source => {
    const messages = responseMessageValues(source)
    if (isMetadataOnlyMessageSource(source)) {
      return messages.filter(value => isNeedLoginMessage(value) || isExplicitBlockingMessageText(value))
    }
    return messages
  })
}

function needLoginMessageValues(source) {
  const content = responseContent(source)
  const sources = [
    source,
    content,
    ...responseBodies(source),
    ...diagnosticBodies(source),
    ...collectDeepMessageBodies(source)
  ]
  return sources.flatMap(responseMessageValues)
}

function unwrapResponseContent(value, depth = 0) {
  const body = normalizeResponseBody(value)
  if (!Object.keys(body).length || depth >= 5) return body
  for (const key of ENVELOPE_KEYS) {
    const nested = body[key]
    if (!nested || (typeof nested !== 'object' && !Array.isArray(nested))) continue
    const unwrapped = unwrapResponseContent(nested, depth + 1)
    if (!Object.keys(unwrapped).length) continue
    const parent = { ...body }
    ENVELOPE_KEYS.forEach(key => {
      delete parent[key]
    })
    return {
      ...parent,
      ...unwrapped
    }
  }
  return body
}

function collectResponseBodies(source, depth = 0, out = []) {
  if (!source || typeof source !== 'object' || depth >= 5) return out
  for (const key of ALL_MARKER_ENVELOPE_KEYS) {
    const value = source[key]
    if (!value || (typeof value !== 'object' && !Array.isArray(value))) continue
    const body = normalizeResponseBody(value)
    if (!Object.keys(body).length) continue
    out.push(body)
    collectNestedResponseBodies(body, depth + 1, out)
    if (Array.isArray(value)) {
      value.forEach(item => {
        const itemBody = normalizeResponseBody(item)
        if (Object.keys(itemBody).length) {
          out.push(itemBody)
          collectNestedResponseBodies(itemBody, depth + 1, out)
        }
        collectResponseBodies(item, depth + 1, out)
      })
    } else {
      collectResponseBodies(body, depth + 1, out)
    }
  }
  return out
}

function collectDeepMarkerBodies(source, depth = 0, out = []) {
  if (!source || typeof source !== 'object' || depth >= 8) return out
  const body = normalizeResponseBody(source)
  if (hasDeepMarkerKey(body) && !out.includes(body)) out.push(body)
  const values = Array.isArray(source) ? source : Object.keys(source).map(key => source[key])
  values.forEach(value => {
    if (value && (typeof value === 'object' || Array.isArray(value))) {
      collectDeepMarkerBodies(value, depth + 1, out)
    }
  })
  return out
}

function hasDeepMarkerKey(body) {
  return hasResponseContent(body) &&
    DEEP_MARKER_KEYS.some(key => Object.prototype.hasOwnProperty.call(body, key))
}

function collectNestedResponseBodies(body, depth = 0, out = []) {
  if (!body || typeof body !== 'object' || depth >= 5) return out
  for (const key of RESPONSE_BODY_KEYS) {
    const value = body[key]
    if (!value || (typeof value !== 'object' && !Array.isArray(value))) continue
    if (Array.isArray(value)) {
      value.forEach(item => {
        const itemBody = normalizeResponseBody(item)
        if (Object.keys(itemBody).length) {
          out.push(itemBody)
          collectNestedResponseBodies(itemBody, depth + 1, out)
        }
        collectResponseBodies(item, depth + 1, out)
      })
      continue
    }
    const nestedBody = normalizeResponseBody(value)
    if (!Object.keys(nestedBody).length) continue
    out.push(nestedBody)
    collectNestedResponseBodies(nestedBody, depth + 1, out)
    collectResponseBodies(nestedBody, depth + 1, out)
  }
  return out
}

function collectDiagnosticBodies(source, depth = 0, out = []) {
  if (!source || typeof source !== 'object' || depth >= 5) return out
  for (const key of DIAGNOSTIC_ENVELOPE_KEYS) {
    const value = source[key]
    if (!value || (typeof value !== 'object' && !Array.isArray(value))) continue
    const body = normalizeResponseBody(value)
    if (Object.keys(body).length) out.push(body)
    if (Array.isArray(value)) {
      value.forEach(item => {
        const itemBody = normalizeResponseBody(item)
        if (Object.keys(itemBody).length) out.push(itemBody)
        collectDiagnosticBodies(item, depth + 1, out)
      })
    } else {
      collectDiagnosticBodies(body, depth + 1, out)
    }
  }
  return out
}

function collectDeepMessageBodies(source, depth = 0, out = []) {
  if (!source || typeof source !== 'object' || depth >= 8) return out
  const body = normalizeResponseBody(source)
  if (responseMessageValues(body).some(value => value !== undefined && value !== null) && !out.includes(body)) out.push(body)
  const values = Array.isArray(source) ? source : Object.keys(source).map(key => source[key])
  values.forEach(value => {
    if (value && (typeof value === 'object' || Array.isArray(value))) {
      collectDeepMessageBodies(value, depth + 1, out)
    }
  })
  return out
}

export function failMessage(res, fallback) {
  const data = requestErrorPayload(res)
  if (isNeedLogin(data)) return needLoginMessage(fallback)
  if (hasUnavailableMarker(data)) return unavailableMessage(data, fallback)
  const message = firstResponseMessage(data)
  if (hasSpecificBackendFailureMessage(message, fallback)) return message
  const content = responseContent(data)
  if (isOkResponse(data) && hasRewardContent(content) && !hasRewardIssueProof(data)) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  return failureFallbackMessage(fallback, 'This feature is temporarily unavailable. Please try again later.')
}

export function unavailableToken(value) {
  return String(value == null ? '' : value).trim().toLowerCase()
}

export function isPositiveFlag(value) {
  if (value === true || value === 1) return true
  const normalized = String(value).trim().toLowerCase()
  return SUCCESS_TOKENS.includes(normalized)
}

export function isNegativeFlag(value) {
  if (value === false || value === 0) return true
  const normalized = String(value).trim().toLowerCase()
  return FAILURE_TOKENS.includes(normalized)
}

function isUnavailableToken(value) {
  // Step6:主 token 分类委托 responseGuard 核 union(更广=对领奖更严);
  // ★保留 rewardApi 专属 isUnsafeProofMessageText/isTechnicalFailureMessageText(领奖证明/技术失败消息,核不覆盖,丢了会放过假领奖)。
  return coreIsUnavailableToken(value) ||
    isUnsafeProofMessageText(value) ||
    isTechnicalFailureMessageText(value)
}

function isUnavailableMessageText(value) {
  const text = unavailableToken(value)
  return !!text && (
    isUnsafeProofMessageText(value) ||
    isTechnicalFailureMessageText(value) ||
    text.includes('未接入') ||
    text.includes('只读') ||
    text.includes('阻止假成功') ||
    text.includes('阻止假发奖') ||
    text.includes('failclosed') ||
    text.includes('fail_closed') ||
    text.includes('fail closed') ||
    text.includes('fail-closed') ||
    text.includes('falseproof') ||
    text.includes('false_proof') ||
    text.includes('false proof') ||
    text.includes('false-proof') ||
    text.includes('未执行') ||
    text.includes('fallback') ||
    text.includes('dataunavailable') ||
    text.includes('data_unavailable') ||
    text.includes('data unavailable') ||
    text.includes('readfailure') ||
    text.includes('read_failure') ||
    text.includes('read failure') ||
    text.includes('read-failure') ||
    text.includes('read blocked') ||
    text.includes('read-blocked') ||
    text.includes('readunavailable') ||
    text.includes('read_unavailable') ||
    text.includes('read unavailable') ||
    text.includes('read-unavailable') ||
    text.includes('routeunavailable') ||
    text.includes('route_unavailable') ||
    text.includes('route unavailable') ||
    text.includes('route-unavailable') ||
    text.includes('readonlyreward') ||
    text.includes('read_only_reward') ||
    text.includes('read only reward') ||
    text.includes('read-only-reward') ||
    text.includes('readonlyaction') ||
    text.includes('read_only_action') ||
    text.includes('read only action') ||
    text.includes('read-only-action') ||
    text.includes('not connected') ||
    text.includes('notimplemented') ||
    text.includes('not implemented') ||
    text.includes('unimplemented') ||
    /(^|[\s_-])blocked($|[\s_-])/.test(text) ||
    text.includes('write blocked') ||
    text.includes('write-blocked') ||
    text.includes('read-only') ||
    text.includes('read only')
  )
}

function isExplicitBlockingMessageText(value) {
  const text = unavailableToken(value)
  return !!text && (
    isUnsafeProofMessageText(value) ||
    isTechnicalFailureMessageText(value) ||
    text.includes('未接入') ||
    text.includes('未执行') ||
    text.includes('未執行') ||
    text.includes('阻止假成功') ||
    text.includes('阻止假发奖') ||
    text.includes('阻止假發獎') ||
    text.includes('阻止假抽奖') ||
    text.includes('阻止假抽獎') ||
    text.includes('failclosed') ||
    text.includes('fail_closed') ||
    text.includes('fail closed') ||
    text.includes('fail-closed') ||
    text.includes('falseproof') ||
    text.includes('false_proof') ||
    text.includes('false proof') ||
    text.includes('false-proof') ||
    text.includes('fake success') ||
    text.includes('fake reward') ||
    text.includes('not executed') ||
    text.includes('notimplemented') ||
    text.includes('not implemented') ||
    text.includes('unimplemented') ||
    text.includes('not connected') ||
    text.includes('write blocked') ||
    text.includes('write-blocked') ||
    text.includes('readonlyreward') ||
    text.includes('read_only_reward') ||
    text.includes('read only reward') ||
    text.includes('read-only-reward') ||
    text.includes('readonlyaction') ||
    text.includes('read_only_action') ||
    text.includes('read only action') ||
    text.includes('read-only-action') ||
    text.includes('backend blocked') ||
    text.includes('backendblocked') ||
    text.includes('backend_blocked') ||
    text.includes('backend-blocked') ||
    text.includes('backend failure') ||
    text.includes('backendfailure') ||
    text.includes('backend_failure') ||
    text.includes('backend-failure') ||
    text.includes('payment backend blocked') ||
    text.includes('paymentbackendblocked') ||
    text.includes('payment_backend_blocked') ||
    text.includes('payment-backend-blocked') ||
    text.includes('data unavailable') ||
    text.includes('data_unavailable') ||
    text.includes('dataunavailable') ||
    text.includes('read failure') ||
    text.includes('read_failure') ||
    text.includes('readfailure') ||
    text.includes('read-failure') ||
    text.includes('read unavailable') ||
    text.includes('read_unavailable') ||
    text.includes('readunavailable') ||
    text.includes('read-unavailable') ||
    text.includes('route unavailable') ||
    text.includes('route_unavailable') ||
    text.includes('routeunavailable') ||
    text.includes('route-unavailable') ||
    text.includes('service unavailable') ||
    text.includes('reward failed')
  )
}

function isActiveGuardFlag(value) {
  if (value === true || value === 1) return true
  const normalized = unavailableToken(value)
  return [
    '1',
    'true',
    'yes',
    'y',
    'on',
    'active',
    'enabled'
  ].includes(normalized) || isUnavailableToken(value)
}

function isExplicitMarkerFlag(value) {
  if (value === undefined || value === null || value === '') return false
  if (value === false || value === 0) return false
  const normalized = unavailableToken(value)
  return ![
    '0',
    'false',
    'no',
    'n',
    'off',
    'none',
    'null',
    'undefined'
  ].includes(normalized)
}

function isUnavailableMarkerFlag(value) {
  return isActiveGuardFlag(value) || isExplicitMarkerFlag(value)
}

function unavailableMarkerFlagValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    ...technicalMarkerFlagValues(source),
    source.readOnlyMode,
    source.read_only_mode,
    source.readOnlyReward,
    source.read_only_reward,
    source.readOnlyAction,
    source.read_only_action,
    source.mockMode,
    source.mock_mode,
    source.backendBlocked,
    source.backend_blocked,
    source.paymentBackendBlocked,
    source.payment_backend_blocked,
    source.paymentStatusUnconfirmed,
    source.payment_status_unconfirmed,
    source.writeBlocked,
    source.write_blocked,
    source.dataUnavailable,
    source.data_unavailable,
    source.readFailure,
    source.read_failure,
    source.readBlocked,
    source.read_blocked,
    source.readUnavailable,
    source.read_unavailable,
    source.needLogin,
    source.need_login,
    source.loginRequired,
    source.login_required,
    source.requireLogin,
    source.require_login,
    source.routeUnavailable,
    source.route_unavailable,
    source.notConnected,
    source.not_connected,
    source.falseProof,
    source.false_proof,
    source.fallbackSource,
    source.fallback_source,
    source.failClosed,
    source.fail_closed,
    source.localFallback,
    source.local_fallback
  ]
}

function hardUnavailableMarkerFlagValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    ...technicalMarkerFlagValues(source),
    source.mockMode,
    source.mock_mode,
    source.readOnlyAction,
    source.read_only_action,
    source.backendBlocked,
    source.backend_blocked,
    source.paymentBackendBlocked,
    source.payment_backend_blocked,
    source.paymentStatusUnconfirmed,
    source.payment_status_unconfirmed,
    source.writeBlocked,
    source.write_blocked,
    source.dataUnavailable,
    source.data_unavailable,
    source.readFailure,
    source.read_failure,
    source.readBlocked,
    source.read_blocked,
    source.readUnavailable,
    source.read_unavailable,
    source.routeUnavailable,
    source.route_unavailable,
    source.notConnected,
    source.not_connected,
    source.falseProof,
    source.false_proof,
    source.fallbackSource,
    source.fallback_source,
    source.failClosed,
    source.fail_closed,
    source.localFallback,
    source.local_fallback
  ]
}

function technicalMarkerFlagValues(source) {
  if (!source || typeof source !== 'object') return []
  return TECHNICAL_MARKER_KEYS.map(key => source[key])
}

function isTechnicalFailureMessageText(value) {
  const text = unavailableToken(value)
  if (!text) return false
  return TECHNICAL_UNAVAILABLE_TOKENS.includes(text) ||
    text.includes('technicalerror') ||
    text.includes('technical_error') ||
    text.includes('technical error') ||
    text.includes('technical-error') ||
    text.includes('technicalexception') ||
    text.includes('technical_exception') ||
    text.includes('technical exception') ||
    text.includes('technical-exception') ||
    text.includes('technicalmarker') ||
    text.includes('technical_marker') ||
    text.includes('technical marker') ||
    text.includes('technical-marker') ||
    text.includes('backendfailure') ||
    text.includes('backend_failure') ||
    text.includes('backend failure') ||
    text.includes('backend-failure') ||
    text.includes('技术错误') ||
    text.includes('技术异常')
}

function isUnsafeProofMessageText(value) {
  const text = unavailableToken(value)
  if (!text) return false
  const compact = text.replace(/[\s_-]+/g, '')
  const unsafeValues = ['false', '0', 'no', 'off', 'none', 'null', 'undefined', 'placeholder']
  const proofKeys = [
    'writeproof',
    'rewardproof',
    'rewardissueproof',
    'serverproof',
    'serverrewardproof',
    'affectedproof',
    'orderproof',
    'paymentproof'
  ]
  return proofKeys.some(key => unsafeValues.some(flag => {
    return compact.includes(`${key}:${flag}`) ||
      compact.includes(`${key}=${flag}`) ||
      compact.includes(`${key}${flag}`)
  }))
}

function proofFlagValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    source.rewardProof,
    source.reward_proof,
    source.rewardIssueProof,
    source.reward_issue_proof,
    source.serverProof,
    source.server_proof,
    source.affectedProof,
    source.affected_proof,
    source.paymentProof,
    source.payment_proof,
    source.writeProof,
    source.write_proof,
    source.orderProof,
    source.order_proof,
    source.falseProof,
    source.false_proof,
    source.serverCanClaim,
    source.server_can_claim
  ]
}

function affectedRowsValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    source.affectedRows,
    source.affected_rows
  ]
}

function hasRewardWriteCountContext(source) {
  if (!source || typeof source !== 'object') return false
  return [
    source.receiveSuccess,
    source.claimSuccess,
    source.signSuccess,
    source.paySuccess,
    source.success,
    source.received,
    source.claimed,
    source.signed,
    source.receiveStatus,
    source.claimStatus,
    ...proofFlagValues(source),
    ...rewardAliasProofValues(source),
    ...rewardRecordProofValues(source)
  ].some(isPresentProofValue)
}

function writeCountValues(source) {
  if (!source || typeof source !== 'object') return []
  const values = [
    ...affectedRowsValues(source),
    source.affected,
    source.rowsAffected,
    source.rows_affected,
    source.rowCount,
    source.row_count,
    source.writeCount,
    source.write_count
  ]
  if (hasRewardWriteCountContext(source)) {
    values.push(source.count)
  }
  return values
}

function hasNonPositiveWriteCount(source) {
  return writeCountValues(source).some(value => {
    if (value === undefined || value === null || value === '') return false
    if (value === false || value === 0) return true
    if (value === true || value === 1) return false
    const number = Number(value)
    if (Number.isFinite(number)) return number <= 0
    const token = unavailableToken(value)
    return ['false', 'no', 'off', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder'].includes(token) ||
      isUnavailableToken(value)
  })
}

function hasNonPositiveAffectedRows(source) {
  return hasNonPositiveWriteCount(source)
}

function hasNonPositiveAffectedRowsInResponse(res) {
  const c = responseContent(res)
  const bodies = responseBodies(res)
  return [res, c, ...bodies].some(hasNonPositiveAffectedRows)
}

function rewardAliasProofValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    source.serverRewardProof,
    source.server_reward_proof,
    source.rewardIssued,
    source.reward_issued
  ]
}

function concreteRewardAliasProofValues(source) {
  return rewardAliasProofValues(source).filter(value => !isPositiveFlag(value) && !isNegativeFlag(value))
}

function rewardRecordProofValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    source.recordNo,
    source.record_no,
    source.recordId,
    source.record_id,
    source.rewardRecordNo,
    source.reward_record_no,
    source.rewardRecordId,
    source.reward_record_id,
    source.receiveRecordNo,
    source.receive_record_no,
    source.receiveRecordId,
    source.receive_record_id,
    source.claimRecordNo,
    source.claim_record_no,
    source.claimRecordId,
    source.claim_record_id,
    source.drawRecordNo,
    source.draw_record_no,
    source.drawRecordId,
    source.draw_record_id
  ]
}

function signRecordProofValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    source.signRecordProof,
    source.sign_record_proof,
    source.signWriteProof,
    source.sign_write_proof
  ]
}

function isSignRecordProofSource(source) {
  if (!source || typeof source !== 'object') return false
  const scope = unavailableToken(firstValue(
    source.rewardProofScope,
    source.reward_proof_scope,
    source.proofScope,
    source.proof_scope
  ))
  const scopedToSignRecord = ['sign_record', 'sign-record', 'signrecord'].includes(scope)
  return scopedToSignRecord && signRecordProofValues(source).some(isPositiveFlag)
}

export function hasUnavailableMarker(payload) {
  if (!payload || typeof payload !== 'object') return false
  const content = responseContent(payload)
  const bodies = responseBodies(payload)
  const directFlags = [
    payload.readOnly,
    payload.readOnlyMode,
    payload.readOnlyReward,
    payload.readonly,
    payload.read_only,
    payload.read_only_mode,
    payload.read_only_reward,
    payload.readOnlyQuery,
    payload.read_only_query,
    payload.readOnlyAction,
    payload.read_only_action,
    payload.unimplemented,
    payload.notImplemented,
    payload.not_implemented,
    payload.unsupported,
    payload.notSupported,
    payload.not_supported,
    payload.stub,
    payload.fallback,
    payload.fallbackUsed,
    payload.fallback_used,
    payload.failClosed,
    payload.fail_closed,
    payload.dataUnavailable,
    payload.data_unavailable,
    payload.mock,
    payload.mockMode,
    payload.mock_mode,
    payload.mockFallback,
    payload.mock_fallback,
    payload.blocked,
    payload.writeBlocked,
    payload.write_blocked,
    payload.backendBlocked,
    payload.backend_blocked,
    payload.missingTable,
    payload.missing_table,
    payload.missingColumn,
    payload.missing_column,
    payload.paymentStatusUnconfirmed,
    payload.payment_status_unconfirmed,
    payload.rewardBackendBlocked,
    payload.reward_backend_blocked,
    payload.notConnected,
    payload.not_connected,
    payload.routeUnavailable,
    payload.route_unavailable,
    payload.failed,
    content.readOnly,
    content.readOnlyMode,
    content.readOnlyReward,
    content.readonly,
    content.read_only,
    content.read_only_mode,
    content.read_only_reward,
    content.readOnlyQuery,
    content.read_only_query,
    content.readOnlyAction,
    content.read_only_action,
    content.unimplemented,
    content.notImplemented,
    content.not_implemented,
    content.unsupported,
    content.notSupported,
    content.not_supported,
    content.stub,
    content.fallback,
    content.fallbackUsed,
    content.fallback_used,
    content.failClosed,
    content.fail_closed,
    content.dataUnavailable,
    content.data_unavailable,
    content.mock,
    content.mockMode,
    content.mock_mode,
    content.mockFallback,
    content.mock_fallback,
    content.blocked,
    content.writeBlocked,
    content.write_blocked,
    content.backendBlocked,
    content.backend_blocked,
    content.missingTable,
    content.missing_table,
    content.missingColumn,
    content.missing_column,
    content.paymentStatusUnconfirmed,
    content.payment_status_unconfirmed,
    content.rewardBackendBlocked,
    content.reward_backend_blocked,
    content.notConnected,
    content.not_connected,
    content.routeUnavailable,
    content.route_unavailable,
    content.failed,
    ...bodies.flatMap(body => [
      body.readOnly,
      body.readOnlyMode,
      body.readOnlyReward,
      body.readonly,
      body.read_only,
      body.read_only_mode,
      body.read_only_reward,
      body.readOnlyQuery,
      body.read_only_query,
      body.readOnlyAction,
      body.read_only_action,
      body.unimplemented,
      body.notImplemented,
      body.not_implemented,
      body.unsupported,
      body.notSupported,
      body.not_supported,
      body.stub,
      body.fallback,
      body.fallbackUsed,
      body.fallback_used,
      body.failClosed,
      body.fail_closed,
      body.dataUnavailable,
      body.data_unavailable,
      body.mock,
      body.mockMode,
      body.mock_mode,
      body.mockFallback,
      body.mock_fallback,
      body.blocked,
      body.writeBlocked,
      body.write_blocked,
      body.backendBlocked,
      body.backend_blocked,
      body.missingTable,
      body.missing_table,
      body.missingColumn,
      body.missing_column,
      body.paymentStatusUnconfirmed,
      body.payment_status_unconfirmed,
      body.rewardBackendBlocked,
      body.reward_backend_blocked,
      body.notConnected,
      body.not_connected,
      body.routeUnavailable,
      body.route_unavailable,
      body.failed
    ])
  ]
  const markerFlags = [payload, content, ...bodies].flatMap(unavailableMarkerFlagValues)
  if (directFlags.some(isActiveGuardFlag) || markerFlags.some(isUnavailableMarkerFlag)) return true
  const negativeProofFlags = [
    payload.rewardProof,
    payload.reward_proof,
    payload.writeProof,
    payload.write_proof,
    payload.orderProof,
    payload.order_proof,
    content.rewardProof,
    content.reward_proof,
    content.writeProof,
    content.write_proof,
    content.orderProof,
    content.order_proof,
    ...bodies.flatMap(body => [
      body.rewardProof,
      body.reward_proof,
      body.writeProof,
      body.write_proof,
      body.orderProof,
      body.order_proof
    ]),
    ...[payload, content, ...bodies].flatMap(proofFlagValues),
    ...[payload, content, ...bodies].flatMap(source => isSignRecordProofSource(source) ? [] : rewardAliasProofValues(source))
  ]
  if (negativeProofFlags.some(isUnsafeProofMarkerValue)) return true
  if ([payload.success, content.success, ...bodies.map(body => body.success)].some(value => value === false || unavailableToken(value) === 'false')) return true
  const markers = [
    payload.status,
    payload.state,
    payload.result,
    payload.code,
    payload.errorCode,
    payload.blocked,
    payload.writeBlocked,
    payload.write_blocked,
    payload.backendBlocked,
    payload.backend_blocked,
    payload.missingTable,
    payload.missing_table,
    payload.missingColumn,
    payload.missing_column,
    payload.rewardBackendBlocked,
    payload.reward_backend_blocked,
    payload.notConnected,
    payload.not_connected,
    payload.unsupported,
    payload.notSupported,
    payload.not_supported,
    payload.failed,
    payload.success,
    payload.receiveSuccess,
    payload.claimSuccess,
    payload.signSuccess,
    payload.paySuccess,
    content.status,
    content.state,
    content.result,
    content.code,
    content.errorCode,
    content.blocked,
    content.writeBlocked,
    content.write_blocked,
    content.backendBlocked,
    content.backend_blocked,
    content.missingTable,
    content.missing_table,
    content.missingColumn,
    content.missing_column,
    content.rewardBackendBlocked,
    content.reward_backend_blocked,
    content.notConnected,
    content.not_connected,
    content.unsupported,
    content.notSupported,
    content.not_supported,
    content.failed,
    content.success,
    content.receiveSuccess,
    content.claimSuccess,
    content.signSuccess,
    content.paySuccess
  ]
  bodies.forEach(body => {
    markers.push(
      body.status,
      body.state,
      body.result,
      body.code,
      body.errorCode,
      body.blocked,
      body.writeBlocked,
      body.write_blocked,
      body.backendBlocked,
      body.backend_blocked,
      body.missingTable,
      body.missing_table,
      body.missingColumn,
      body.missing_column,
      body.rewardBackendBlocked,
      body.reward_backend_blocked,
      body.notConnected,
      body.not_connected,
      body.unsupported,
      body.notSupported,
      body.not_supported,
      body.failed,
      body.success,
      body.receiveSuccess,
      body.claimSuccess,
      body.signSuccess,
      body.paySuccess
    )
  })
  const messages = blockingResponseMessages([payload, ...bodies])
  return markers.some(value => isUnavailableToken(value)) ||
    messages.some(value => isUnavailableToken(value) || isUnavailableMessageText(value))
}

export function isOkResponse(res) {
  if (isNeedLogin(res)) return false
  if (!res || !hasOkMarker(res) || hasBusinessFailureMarker(res)) return false
  return !hasUnavailableMarker(res) || isReadableOkResponse(res)
}

function hasOkMarker(res) {
  const content = responseContent(res)
  const bodies = responseBodies(res)
  return [res, content, ...bodies].some(source => {
    if (!source || typeof source !== 'object') return false
    return [
      source.status,
      source.state,
      source.result
    ].some(value => isOkStatusToken(value) || isOkCodeToken(value)) || [
      source.code,
      source.errorCode
    ].some(isOkCodeToken) || [
      source.success,
      source.receiveSuccess,
      source.claimSuccess,
      source.signSuccess,
      source.paySuccess
    ].some(isPositiveFlag)
  })
}

function hasDiagnosticUnavailableMarker(res) {
  const bodies = diagnosticBodies(res)
  const flags = bodies.flatMap(body => [
    body.readOnly,
    body.readOnlyMode,
    body.readOnlyReward,
    body.readonly,
    body.read_only,
    body.read_only_mode,
    body.read_only_reward,
    body.readOnlyQuery,
    body.read_only_query,
    body.unimplemented,
    body.notImplemented,
    body.not_implemented,
    body.unsupported,
    body.notSupported,
    body.not_supported,
    body.stub,
    body.fallback,
    body.fallbackUsed,
    body.fallback_used,
    body.dataUnavailable,
    body.data_unavailable,
    body.mock,
    body.mockMode,
    body.mock_mode,
    body.mockFallback,
    body.mock_fallback,
    body.blocked,
    body.writeBlocked,
    body.write_blocked,
    body.backendBlocked,
    body.backend_blocked,
    body.paymentStatusUnconfirmed,
    body.payment_status_unconfirmed,
    body.rewardBackendBlocked,
    body.reward_backend_blocked,
    body.notConnected,
    body.not_connected,
    body.failed,
    body.success
  ])
  const markerFlags = bodies.flatMap(unavailableMarkerFlagValues)
  if (flags.some(value => isActiveGuardFlag(value) || isBlockingReadToken(value)) ||
    markerFlags.some(isUnavailableMarkerFlag)) return true
  const negativeProofFlags = bodies.flatMap(body => [
    body.rewardProof,
    body.reward_proof,
    body.serverProof,
    body.server_proof,
    body.affectedProof,
    body.affected_proof,
    body.writeProof,
    body.write_proof,
    body.orderProof,
    body.order_proof,
    ...proofFlagValues(body),
    ...rewardAliasProofValues(body)
  ])
  if (negativeProofFlags.some(isUnsafeProofMarkerValue)) return true
  const values = bodies.flatMap(body => [
    body.status,
    body.state,
    body.result,
    body.code,
    body.errorCode
  ])
  const messages = bodies.flatMap(body => [
    body.msg,
    body.message,
    body.reason,
    body.desc,
    body.description
  ])
  return values.some(isBlockingReadToken) ||
    messages.some(value => isUnavailableToken(value) || isUnavailableMessageText(value))
}

export function isReadableOkResponse(res) {
  if (!res || !hasOkMarker(res)) return false
  const content = responseContent(res)
  const bodies = responseBodies(res)
  if (hasDiagnosticUnavailableMarker(res)) return false
  const readOnlyFlags = [
    res.readOnly,
    res.readOnlyMode,
    res.readOnlyReward,
    res.readonly,
    res.read_only,
    res.read_only_mode,
    res.read_only_reward,
    content.readOnly,
    content.readOnlyMode,
    content.readOnlyReward,
    content.readonly,
    content.read_only,
    content.read_only_mode,
    content.read_only_reward,
    ...bodies.flatMap(body => [
      body.readOnly,
      body.readOnlyMode,
      body.readOnlyReward,
      body.readonly,
      body.read_only,
      body.read_only_mode,
      body.read_only_reward
    ])
  ]
  const blockingFlags = [
    res.mock,
    res.mockMode,
    res.mock_mode,
    res.mockFallback,
    res.mock_fallback,
    res.blocked,
    res.unimplemented,
    res.notImplemented,
    res.not_implemented,
    res.unsupported,
    res.notSupported,
    res.not_supported,
    res.stub,
    res.fallback,
    res.fallbackUsed,
    res.fallback_used,
    res.dataUnavailable,
    res.data_unavailable,
    res.writeBlocked,
    res.write_blocked,
    res.readOnlyAction,
    res.read_only_action,
    res.backendBlocked,
    res.backend_blocked,
    res.rewardBackendBlocked,
    res.reward_backend_blocked,
    res.notConnected,
    res.not_connected,
    res.failed,
    content.mock,
    content.mockMode,
    content.mock_mode,
    content.mockFallback,
    content.mock_fallback,
    content.blocked,
    content.unimplemented,
    content.notImplemented,
    content.not_implemented,
    content.unsupported,
    content.notSupported,
    content.not_supported,
    content.stub,
    content.fallback,
    content.fallbackUsed,
    content.fallback_used,
    content.dataUnavailable,
    content.data_unavailable,
    content.writeBlocked,
    content.write_blocked,
    content.readOnlyAction,
    content.read_only_action,
    content.backendBlocked,
    content.backend_blocked,
    content.rewardBackendBlocked,
    content.reward_backend_blocked,
    content.notConnected,
    content.not_connected,
    content.failed,
    ...bodies.flatMap(body => [
      body.mock,
      body.mockMode,
      body.mock_mode,
      body.mockFallback,
      body.mock_fallback,
      body.blocked,
      body.unimplemented,
      body.notImplemented,
      body.not_implemented,
      body.unsupported,
      body.notSupported,
      body.not_supported,
      body.stub,
      body.fallback,
      body.fallbackUsed,
      body.fallback_used,
      body.dataUnavailable,
      body.data_unavailable,
      body.writeBlocked,
      body.write_blocked,
      body.readOnlyAction,
      body.read_only_action,
      body.backendBlocked,
      body.backend_blocked,
      body.rewardBackendBlocked,
      body.reward_backend_blocked,
      body.notConnected,
      body.not_connected,
      body.failed
    ])
  ]
  const markerFlags = [res, content, ...bodies].flatMap(hardUnavailableMarkerFlagValues)
  if (blockingFlags.some(value => isActiveGuardFlag(value) || isBlockingReadToken(value)) ||
    markerFlags.some(isUnavailableMarkerFlag)) return false
  const negativeProofFlags = [
    res.rewardProof,
    res.reward_proof,
    res.writeProof,
    res.write_proof,
    res.orderProof,
    res.order_proof,
    content.rewardProof,
    content.reward_proof,
    content.writeProof,
    content.write_proof,
    content.orderProof,
    content.order_proof,
    ...bodies.flatMap(body => [
      body.rewardProof,
      body.reward_proof,
      body.writeProof,
      body.write_proof,
      body.orderProof,
      body.order_proof
    ]),
    ...[res, content, ...bodies].flatMap(proofFlagValues),
    ...[res, content, ...bodies].flatMap(rewardAliasProofValues)
  ]
  if (negativeProofFlags.some(isUnsafeProofMarkerValue)) return false
  const messages = blockingResponseMessages([res, ...bodies])
  if (messages.some(value => isUnavailableToken(value) || isUnavailableMessageText(value))) return false
  if (readOnlyFlags.some(isActiveGuardFlag) && ![content, ...bodies].some(hasMeaningfulResponseBody)) return false
  if ([res.success, content.success, ...bodies.map(body => body.success)].some(value => value === false || unavailableToken(value) === 'false')) return false
  if (hasBusinessFailureMarker(res)) return false
  return ![
    res.status,
    res.state,
    res.result,
    res.code,
    res.errorCode,
    content.status,
    content.state,
    content.result,
    content.code,
    content.errorCode,
    ...bodies.flatMap(body => [
      body.status,
      body.state,
      body.result,
      body.code,
      body.errorCode
    ])
  ].some(isBlockingReadToken)
}

function hasBusinessFailureMarker(res) {
  const content = responseContent(res)
  const bodies = responseBodies(res)
  return [res, content, ...bodies].some(source => {
    if (!source || typeof source !== 'object') return false
    return [
      source.status,
      source.state,
      source.result
    ].some(isFailureStatusToken) || [
      source.code,
      source.errorCode
    ].some(isFailureCodeToken)
  })
}

function serverReadProofValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    source.serverReadProof,
    source.server_read_proof,
    source.readProof,
    source.read_proof,
    source.queryProof,
    source.query_proof
  ]
}

function hasReadOnlyQueryMarker(source) {
  if (!source || typeof source !== 'object') return false
  return [source.readOnlyQuery, source.read_only_query].some(isActiveGuardFlag)
}

function hasEmptyReadList(source) {
  if (!source || typeof source !== 'object') return false
  return [
    source.list,
    source.dataList,
    source.records,
    source.rows,
    source.items,
    source.pageList,
    source.rewardHistoryList,
    source.signRecordList,
    source.signHistoryList
  ].some(value => Array.isArray(value) && value.length === 0)
}

function hasPositiveReadTotal(source) {
  if (!source || typeof source !== 'object') return false
  return [
    source.total,
    source.totalCount,
    source.total_count,
    source.count,
    source.totalSize,
    source.total_size,
    source.totalPage,
    source.total_page,
    source.totalPages,
    source.total_pages
  ].some(value => {
    const number = Number(value)
    return Number.isFinite(number) && number > 0
  })
}

function hasReadFailureMarker(source) {
  if (!source || typeof source !== 'object') return false
  return [
    source.mock,
    source.mockMode,
    source.mock_mode,
    source.mockFallback,
    source.mock_fallback,
    source.stub,
    source.fallback,
    source.fallbackUsed,
    source.fallback_used,
    source.fallbackSource,
    source.fallback_source,
    source.localFallback,
    source.local_fallback,
    source.dataUnavailable,
    source.data_unavailable,
    source.readFailure,
    source.read_failure,
    source.readBlocked,
    source.read_blocked,
    source.readUnavailable,
    source.read_unavailable,
    source.routeUnavailable,
    source.route_unavailable,
    source.readOnlyAction,
    source.read_only_action,
    source.readOnlyReward,
    source.read_only_reward,
    source.writeBlocked,
    source.write_blocked,
    source.backendBlocked,
    source.backend_blocked,
    source.rewardBackendBlocked,
    source.reward_backend_blocked,
    source.paymentBackendBlocked,
    source.payment_backend_blocked,
    source.notConnected,
    source.not_connected,
    source.failClosed,
    source.fail_closed,
    source.falseProof,
    source.false_proof,
    source.unimplemented,
    source.notImplemented,
    source.not_implemented,
    source.unsupported,
    source.notSupported,
    source.not_supported,
    source.failed,
    ...technicalMarkerFlagValues(source),
    ...hardUnavailableMarkerFlagValues(source)
  ].some(value => isUnavailableMarkerFlag(value) || isBlockingReadToken(value))
}

function hasWriteSuccessMarker(source) {
  if (!source || typeof source !== 'object') return false
  return [
    source.success,
    source.receiveSuccess,
    source.claimSuccess,
    source.signSuccess,
    source.paySuccess,
    source.received,
    source.claimed,
    source.signed
  ].some(isPositiveFlag) || hasRewardContent(source)
}

export function hasServerProvenEmptyRead(res) {
  if (!res || !hasOkMarker(res) || hasBusinessFailureMarker(res)) return false
  const content = responseContent(res)
  const bodies = responseBodies(res)
  const sources = [res, content, ...bodies]
  if (!sources.some(hasReadOnlyQueryMarker)) return false
  if (!sources.flatMap(serverReadProofValues).some(value => hasSafeProofValue([value]))) return false
  if (!sources.some(hasEmptyReadList)) return false
  if (sources.some(hasPositiveReadTotal)) return false
  if (sources.some(hasReadFailureMarker)) return false
  if (sources.some(hasWriteSuccessMarker)) return false
  const messages = blockingResponseMessages([res, ...bodies])
  if (messages.some(value => isUnavailableToken(value) || isUnavailableMessageText(value))) return false
  return true
}

function isFailureStatusToken(value) {
  const token = unavailableToken(value)
  return [
    'fail',
    'failed',
    'failure',
    'error',
    'rejected',
    'reject',
    'blocked',
    'disabled',
    'falseproof',
    'false_proof',
    'false-proof',
    'false proof'
  ].includes(token)
}

function isOkStatusToken(value) {
  const token = unavailableToken(value)
  return ['ok', 'success', 'successful', 'succeed', 'succeeded', 'completed'].includes(token)
}

function isFailureCodeToken(value) {
  const token = unavailableToken(value)
  if (!token || isOkCodeToken(token) || token === 'need_login') return false
  if (/^[45]\d{2,}$/.test(token)) return true
  return token.includes('error') || token.includes('fail') || token.startsWith('e_')
}

function isOkCodeToken(value) {
  const token = unavailableToken(value)
  return ['0', '00', '0000', '000000', '200', 'ok', 'success'].includes(token)
}

function firstResponseMessage(res) {
  const content = responseContent(res)
  const bodies = responseBodies(res)
  for (const source of [res, content, ...bodies]) {
    const value = source && firstValue(
      source.msg,
      source.message,
      source.errorMsg,
      source.errorMessage,
      source.reason,
      source.desc,
      source.description,
      source.detail
    )
    if (value && typeof value !== 'object') return value
  }
  return ''
}

function isBlockingReadToken(value) {
  const normalized = unavailableToken(value)
  return !!normalized && (
    [
      'stub',
      'mock',
      'mock_fallback',
      'mock-fallback',
      'mock fallback',
      'fail',
      'failed',
      'failure',
      'error',
      'rejected',
      'blocked',
      'fallback',
      'fallback_used',
      'fallback used',
      'dataunavailable',
      'data_unavailable',
      'data unavailable',
      'readfailure',
      'read_failure',
      'read failure',
      'read-failure',
      'read_blocked',
      'readblocked',
      'read blocked',
      'read-blocked',
      'routeunavailable',
      'route_unavailable',
      'route unavailable',
      'route-unavailable',
      'read_only_reward',
      'readonlyreward',
      'read only reward',
      'read-only-reward',
      'read_only_action',
      'readonlyaction',
      'read only action',
      'read-only-action',
      'unavailable',
      'disabled',
      'unimplemented',
      'not_implemented',
      'notimplemented',
      'not implemented',
      'not_supported',
      'not-supported',
      'not supported',
      'not_connected',
      'not-connected',
      'not connected',
      'need_login',
      'write_blocked',
      'writeblocked',
      'write blocked',
      'write-blocked',
      'backend_blocked',
      'backendblocked',
      'backend blocked',
      'backend-blocked',
      'reward_backend_blocked',
      'rewardbackendblocked',
      'reward backend blocked',
      'reward-backend-blocked',
      'payment_backend_blocked',
      'paymentbackendblocked',
      'payment backend blocked',
      'payment-backend-blocked',
      ...TECHNICAL_UNAVAILABLE_TOKENS,
      'unsupported'
    ].includes(normalized) ||
    isTechnicalFailureMessageText(value) ||
    normalized.includes('mock') ||
    normalized.includes('fallback') ||
    normalized.includes('dataunavailable') ||
    normalized.includes('data_unavailable') ||
    normalized.includes('data unavailable') ||
    normalized.includes('readfailure') ||
    normalized.includes('read_failure') ||
    normalized.includes('read failure') ||
    normalized.includes('read-failure') ||
    normalized.includes('read_blocked') ||
    normalized.includes('readblocked') ||
    normalized.includes('read blocked') ||
    normalized.includes('read-blocked') ||
    normalized.includes('routeunavailable') ||
    normalized.includes('route_unavailable') ||
    normalized.includes('route unavailable') ||
    normalized.includes('route-unavailable') ||
    normalized.includes('readonlyreward') ||
    normalized.includes('read_only_reward') ||
    normalized.includes('read only reward') ||
    normalized.includes('read-only-reward') ||
    normalized.includes('readonlyaction') ||
    normalized.includes('read_only_action') ||
    normalized.includes('read only action') ||
    normalized.includes('read-only-action') ||
    normalized.includes('unimplemented') ||
    normalized.includes('not_implemented') ||
    normalized.includes('notimplemented') ||
    normalized.includes('not implemented') ||
    normalized.includes('not_supported') ||
    normalized.includes('not-supported') ||
    normalized.includes('not supported') ||
    normalized.includes('not_connected') ||
    normalized.includes('not-connected') ||
    normalized.includes('not connected') ||
    normalized.includes('need_login') ||
    normalized.includes('write_blocked') ||
    normalized.includes('writeblocked') ||
    normalized.includes('write blocked') ||
    normalized.includes('write-blocked') ||
    normalized.includes('backend_blocked') ||
    normalized.includes('backendblocked') ||
    normalized.includes('backend blocked') ||
    normalized.includes('backend-blocked') ||
    normalized.includes('reward_backend_blocked') ||
    normalized.includes('rewardbackendblocked') ||
    normalized.includes('reward backend blocked') ||
    normalized.includes('reward-backend-blocked') ||
    normalized.includes('payment_backend_blocked') ||
    normalized.includes('paymentbackendblocked') ||
    normalized.includes('payment backend blocked') ||
    normalized.includes('payment-backend-blocked') ||
    normalized.includes('unsupported')
  )
}

export function unavailableMessage(res, fallback) {
  const content = responseContent(res)
  const bodies = responseBodies(res)
  const backendMessage = firstResponseMessage(res)
  const values = [
    res && res.status,
    res && res.state,
    res && res.result,
    res && res.code,
    res && res.errorCode,
    res && res.blocked,
    res && res.writeBlocked,
    res && res.write_blocked,
    res && res.backendBlocked,
    res && res.backend_blocked,
    res && res.rewardBackendBlocked,
    res && res.reward_backend_blocked,
    res && res.paymentBackendBlocked,
    res && res.payment_backend_blocked,
    res && res.paymentStatusUnconfirmed,
    res && res.payment_status_unconfirmed,
    res && res.notConnected,
    res && res.not_connected,
    res && res.routeUnavailable,
    res && res.route_unavailable,
    res && res.fallback,
    res && res.fallbackUsed,
    res && res.fallback_used,
    res && res.fallbackSource,
    res && res.fallback_source,
    res && res.localFallback,
    res && res.local_fallback,
    res && res.dataUnavailable,
    res && res.data_unavailable,
    res && res.readFailure,
    res && res.read_failure,
    res && res.failed,
    res && res.success,
    content.status,
    content.state,
    content.result,
    content.code,
    content.errorCode,
    content.blocked,
    content.writeBlocked,
    content.write_blocked,
    content.backendBlocked,
    content.backend_blocked,
    content.rewardBackendBlocked,
    content.reward_backend_blocked,
    content.paymentBackendBlocked,
    content.payment_backend_blocked,
    content.paymentStatusUnconfirmed,
    content.payment_status_unconfirmed,
    content.notConnected,
    content.not_connected,
    content.routeUnavailable,
    content.route_unavailable,
    content.fallback,
    content.fallbackUsed,
    content.fallback_used,
    content.fallbackSource,
    content.fallback_source,
    content.localFallback,
    content.local_fallback,
    content.dataUnavailable,
    content.data_unavailable,
    content.readFailure,
    content.read_failure,
    content.failed,
    content.success,
    ...bodies.flatMap(body => [
      body.status,
      body.state,
      body.result,
      body.code,
      body.errorCode,
      body.blocked,
      body.writeBlocked,
      body.write_blocked,
      body.backendBlocked,
      body.backend_blocked,
      body.rewardBackendBlocked,
      body.reward_backend_blocked,
      body.paymentBackendBlocked,
      body.payment_backend_blocked,
      body.paymentStatusUnconfirmed,
      body.payment_status_unconfirmed,
      body.notConnected,
      body.not_connected,
      body.routeUnavailable,
      body.route_unavailable,
      body.fallback,
      body.fallbackUsed,
      body.fallback_used,
      body.fallbackSource,
      body.fallback_source,
      body.localFallback,
      body.local_fallback,
      body.dataUnavailable,
      body.data_unavailable,
      body.readFailure,
      body.read_failure,
      body.failed,
      body.success
    ])
  ]
  if (isNeedLogin(res)) return needLoginMessage(fallback)
  const technicalFlags = [res, content, ...bodies].flatMap(technicalMarkerFlagValues)
  if (technicalFlags.some(isUnavailableMarkerFlag) ||
    values.some(isTechnicalFailureMessageText) ||
    isTechnicalFailureMessageText(backendMessage)) {
    return '奖励服务暂不可用，请稍后重试。'
  }
  if (isUnsafeProofMessageText(backendMessage)) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (hasSpecificBackendFailureMessage(backendMessage, fallback)) return backendMessage
  const writeFlags = [
    res && res.blocked,
    res && res.writeBlocked,
    res && res.write_blocked,
    res && res.backendBlocked,
    res && res.backend_blocked,
    res && res.rewardBackendBlocked,
    res && res.reward_backend_blocked,
    res && res.paymentBackendBlocked,
    res && res.payment_backend_blocked,
    res && res.notConnected,
    res && res.not_connected,
    res && res.routeUnavailable,
    res && res.route_unavailable,
    content.blocked,
    content.writeBlocked,
    content.write_blocked,
    content.backendBlocked,
    content.backend_blocked,
    content.rewardBackendBlocked,
    content.reward_backend_blocked,
    content.paymentBackendBlocked,
    content.payment_backend_blocked,
    content.notConnected,
    content.not_connected,
    content.routeUnavailable,
    content.route_unavailable,
    ...bodies.flatMap(body => [
      body.blocked,
      body.writeBlocked,
      body.write_blocked,
      body.backendBlocked,
      body.backend_blocked,
      body.rewardBackendBlocked,
      body.reward_backend_blocked,
      body.paymentBackendBlocked,
      body.payment_backend_blocked,
      body.notConnected,
      body.not_connected,
      body.routeUnavailable,
      body.route_unavailable
    ])
  ]
  const failedFlags = [
    res && res.failed,
    content.failed,
    ...bodies.map(body => body.failed)
  ]
  const paymentUnconfirmedFlags = [
    res && res.paymentStatusUnconfirmed,
    res && res.payment_status_unconfirmed,
    content.paymentStatusUnconfirmed,
    content.payment_status_unconfirmed,
    ...bodies.flatMap(body => [
      body.paymentStatusUnconfirmed,
      body.payment_status_unconfirmed
    ])
  ]
  const readFlags = [
    res && res.readOnly,
    res && res.readOnlyMode,
    res && res.readOnlyReward,
    res && res.readonly,
    res && res.read_only_mode,
    res && res.read_only_reward,
    res && res.readOnlyQuery,
    res && res.read_only_query,
    res && res.readOnlyAction,
    res && res.read_only_action,
    content.readOnly,
    content.readOnlyMode,
    content.readOnlyReward,
    content.readonly,
    content.read_only_mode,
    content.read_only_reward,
    content.readOnlyQuery,
    content.read_only_query,
    content.readOnlyAction,
    content.read_only_action,
    ...bodies.flatMap(body => [
      body.readOnly,
      body.readOnlyMode,
      body.readOnlyReward,
      body.readonly,
      body.read_only_mode,
      body.read_only_reward,
      body.readOnlyQuery,
      body.read_only_query,
      body.readOnlyAction,
      body.read_only_action
    ])
  ]
  const unimplementedFlags = [
    res && res.unimplemented,
    res && res.notImplemented,
    res && res.not_implemented,
    content.unimplemented,
    content.notImplemented,
    content.not_implemented,
    ...bodies.flatMap(body => [
      body.unimplemented,
      body.notImplemented,
      body.not_implemented
    ])
  ]
  const unsupportedFlags = [
    res && res.unsupported,
    res && res.notSupported,
    res && res.not_supported,
    content.unsupported,
    content.notSupported,
    content.not_supported,
    ...bodies.flatMap(body => [
      body.unsupported,
      body.notSupported,
      body.not_supported
    ])
  ]
  const stubFlags = [
    res && res.stub,
    content.stub,
    ...bodies.map(body => body.stub)
  ]
  const fallbackFlags = [
    res && res.fallback,
    res && res.fallbackUsed,
    res && res.fallback_used,
    res && res.fallbackSource,
    res && res.fallback_source,
    res && res.localFallback,
    res && res.local_fallback,
    content.fallback,
    content.fallbackUsed,
    content.fallback_used,
    content.fallbackSource,
    content.fallback_source,
    content.localFallback,
    content.local_fallback,
    ...bodies.flatMap(body => [
      body.fallback,
      body.fallbackUsed,
      body.fallback_used,
      body.fallbackSource,
      body.fallback_source,
      body.localFallback,
      body.local_fallback
    ])
  ]
  const dataUnavailableFlags = [
    res && res.dataUnavailable,
    res && res.data_unavailable,
    res && res.readFailure,
    res && res.read_failure,
    content.dataUnavailable,
    content.data_unavailable,
    content.readFailure,
    content.read_failure,
    ...bodies.flatMap(body => [
      body.dataUnavailable,
      body.data_unavailable,
      body.readFailure,
      body.read_failure
    ])
  ]
  const mockFlags = [
    res && res.mock,
    res && res.mockMode,
    res && res.mock_mode,
    res && res.mockFallback,
    res && res.mock_fallback,
    content.mock,
    content.mockMode,
    content.mock_mode,
    content.mockFallback,
    content.mock_fallback,
    ...bodies.flatMap(body => [body.mock, body.mockMode, body.mock_mode, body.mockFallback, body.mock_fallback])
  ]
  const successFlags = [
    res && res.success,
    content.success,
    ...bodies.map(body => body.success)
  ]
  const proofFlags = [
    res && res.rewardProof,
    res && res.reward_proof,
    res && res.writeProof,
    res && res.write_proof,
    res && res.orderProof,
    res && res.order_proof,
    content.rewardProof,
    content.reward_proof,
    content.writeProof,
    content.write_proof,
    content.orderProof,
    content.order_proof,
    ...bodies.flatMap(body => [
      body.rewardProof,
      body.reward_proof,
      body.writeProof,
      body.write_proof,
      body.orderProof,
      body.order_proof
    ]),
    ...[res, content, ...bodies].flatMap(proofFlagValues),
    ...[res, content, ...bodies].flatMap(rewardAliasProofValues)
  ]
  if ([...values, backendMessage].some(value => {
    const token = unavailableToken(value)
    return token.includes('falseproof') ||
      token.includes('false_proof') ||
      token.includes('false proof') ||
      token.includes('false-proof')
  })) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (writeFlags.some(isActiveGuardFlag) ||
    [...values, backendMessage].some(value => {
      const token = unavailableToken(value)
      return isUnavailableToken(value) && (
        token === 'blocked' ||
        token.includes('write') ||
        token.includes('backendblocked') ||
        token.includes('backend_blocked') ||
        token.includes('backend failure') ||
        token.includes('backendfailure') ||
        token.includes('backend_failure') ||
        token.includes('backend-failure')
      )
    })) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (paymentUnconfirmedFlags.some(isActiveGuardFlag) ||
    values.some(value => {
      const token = unavailableToken(value)
      return token.includes('paymentstatusunconfirmed') ||
        token.includes('payment_status_unconfirmed') ||
        token.includes('payment status unconfirmed') ||
        token.includes('payment-status-unconfirmed')
    })) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (dataUnavailableFlags.some(isUnavailableMarkerFlag) ||
    [...values, backendMessage].some(value => {
      const token = unavailableToken(value)
      return token.includes('dataunavailable') ||
        token.includes('data_unavailable') ||
        token.includes('data unavailable') ||
        token.includes('readfailure') ||
        token.includes('read_failure') ||
        token.includes('read failure') ||
        token.includes('read-failure') ||
        token.includes('readunavailable') ||
        token.includes('read_unavailable') ||
        token.includes('read unavailable') ||
        token.includes('read-unavailable')
    })) {
    return '活动数据暂不可用（data unavailable），请稍后重试。'
  }
  if (readFlags.some(isActiveGuardFlag) ||
    [...values, backendMessage].some(value => isUnavailableToken(value) && unavailableToken(value).includes('read'))) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (unimplementedFlags.some(isActiveGuardFlag) ||
    values.some(value => isUnavailableToken(value) && (
      unavailableToken(value).includes('unimplemented') ||
      unavailableToken(value).includes('not_implemented') ||
      unavailableToken(value).includes('notimplemented') ||
      unavailableToken(value).includes('not implemented')
    ))) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (unsupportedFlags.some(isActiveGuardFlag) ||
    values.some(value => isUnavailableToken(value) && (
      unavailableToken(value).includes('not_supported') ||
      unavailableToken(value).includes('not-supported') ||
      unavailableToken(value).includes('not supported') ||
      unavailableToken(value).includes('unsupported')
    ))) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (values.some(value => unavailableToken(value) === 'need_login')) return needLoginMessage(fallback)
  if (fallbackFlags.some(isUnavailableMarkerFlag) ||
    dataUnavailableFlags.some(isUnavailableMarkerFlag) ||
    values.some(value => {
      const token = unavailableToken(value)
      return token.includes('fallback') ||
        token.includes('dataunavailable') ||
        token.includes('data_unavailable') ||
        token.includes('data unavailable') ||
        token.includes('readfailure') ||
        token.includes('read_failure') ||
        token.includes('read failure') ||
        token.includes('read-failure')
    })) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (stubFlags.some(isActiveGuardFlag) ||
    mockFlags.some(isActiveGuardFlag) ||
    values.some(value => ['stub', 'mock', 'mock_fallback', 'mock-fallback', 'mock fallback'].includes(unavailableToken(value)))) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (proofFlags.some(isUnsafeProofMarkerValue)) {
    return 'This feature is temporarily unavailable. Please try again later.'
  }
  if (successFlags.some(value => value === false || unavailableToken(value) === 'false')) {
    return failureFallbackMessage(fallback, 'This feature is temporarily unavailable. Please try again later.')
  }
  if (failedFlags.some(isActiveGuardFlag)) {
    return hasSpecificBackendFailureMessage(backendMessage, fallback)
      ? backendMessage
      : failureFallbackMessage(fallback, 'This feature is temporarily unavailable. Please try again later.')
  }
  return hasSpecificBackendFailureMessage(backendMessage, fallback)
    ? backendMessage
    : failureFallbackMessage(fallback, 'This feature is temporarily unavailable. Please try again later.')
}

function isOptimisticSuccessMessage(value) {
  const token = unavailableToken(value)
  if (!token) return false
  const hasSuccessCopy = /\b(?:ok|success|successful|done|saved|complete|completed|sucesso)\b/.test(token) || [
    'ok',
    'success',
    'successful',
    'done',
    'saved',
    'complete',
    'completed',
    'sucesso'
  ].includes(token) || token.includes('成功')
  const hasFailureContext = token.includes('fail') ||
    token.includes('error') ||
    isUnavailableToken(token) ||
    isUnavailableMessageText(token) ||
    token.includes('blocked') ||
    token.includes('阻止') ||
    token.includes('失败') ||
    token.includes('失敗') ||
    token.includes('不可用') ||
    token.includes('未接入') ||
    token.includes('fake') ||
    token.includes('只读') ||
    token.includes('只讀')
  return hasSuccessCopy && !hasFailureContext
}

export function hasRewardContent(content) {
  const c = content || {}
  const positiveRewardValues = [
    c.amount,
    c.reward,
    c.rewardAmount,
    c.awardAmount,
    c.freeSignReward,
    c.paySignReward,
    c.reliefAmount,
    c.bonus,
    c.bonusAmount,
    c.bonusSum,
    c.getBonusSum,
    c.points
  ]
  if (positiveRewardValues.some(value => {
    const numeric = Number(value)
    return Number.isFinite(numeric) && numeric > 0
  })) {
    return true
  }
  return hasSafeProofValue([
    c.orderNo,
    c.orderId,
    c.payOrderNo,
    c.paymentOrderNo,
    c.tradeNo,
    c.recordNo,
    c.recordId,
    c.rewardRecordNo,
    c.rewardRecordId,
    c.drawRecordNo,
    c.drawRecordId,
    c.receiveRecordNo,
    c.claimRecordNo,
    c.businessNo,
    c.businessId,
    c.bizNo,
    c.bizId,
    c.serialNo,
    c.transactionNo,
    c.transactionId,
    c.requestNo,
    ...concreteRewardAliasProofValues(c)
  ])
}

function hasSafeProofValue(values) {
  return values.some(value => {
    if (value && typeof value === 'object') return false
    const token = unavailableToken(value)
    return Boolean(token) &&
      !isNegativeFlag(value) &&
      !isUnavailableToken(value) &&
      ![
        '0',
        'none',
        'null',
        'undefined',
        'placeholder',
        '#',
        'about:blank',
        'javascript:void(0)'
      ].includes(token)
  })
}

function isPresentProofValue(value) {
  return value !== undefined && value !== null && value !== ''
}

function isUnsafeProofMarkerValue(value) {
  return isPresentProofValue(value) && (isNegativeFlag(value) || !hasSafeProofValue([value]))
}

function hasPositiveProofFlag(values) {
  return values.some(value => {
    if (value && typeof value === 'object') return false
    return isPositiveFlag(value) && !isUnavailableToken(value)
  })
}

function rewardProofCandidateValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    ...proofFlagValues(source),
    ...rewardAliasProofValues(source),
    ...rewardRecordProofValues(source)
  ]
}

export function hasSignRecordProof(res) {
  const c = responseContent(res)
  if (!hasResponseContent(c)) return false
  if (hasUnavailableMarker(res)) return false
  if (hasNonPositiveAffectedRowsInResponse(res)) return false
  const bodies = responseBodies(res)
  return [c, ...bodies].some(source => {
    if (!isSignRecordProofSource(source)) return false
    const proofValues = [
      source.signRecordNo,
      source.sign_record_no,
      source.recordNo,
      source.record_no,
      source.rewardRecordNo,
      source.reward_record_no,
      source.idempotencyKey,
      source.idempotency_key,
      source.serialNo,
      source.serial_no
    ]
    return hasSafeProofValue(proofValues)
  })
}

export function hasRewardIssueProof(res) {
  const c = responseContent(res)
  if (!hasResponseContent(c)) return false
  if (hasUnavailableMarker(res)) return false
  if (hasNonPositiveAffectedRowsInResponse(res)) return false
  const bodies = responseBodies(res)
  const aliasProofFlags = [c, ...bodies].flatMap(rewardAliasProofValues)
  const rewardDomainProofFlags = [
    c.rewardProof,
    c.reward_proof,
    c.rewardIssueProof,
    c.reward_issue_proof,
    ...bodies.flatMap(body => [
      body.rewardProof,
      body.reward_proof,
      body.rewardIssueProof,
      body.reward_issue_proof
    ])
  ]
  const proofFlags = [
    ...rewardDomainProofFlags,
    c.serverProof,
    c.server_proof,
    c.affectedProof,
    c.affected_proof,
    c.paymentProof,
    c.payment_proof,
    c.writeProof,
    c.write_proof,
    c.orderProof,
    c.order_proof,
    c.serverCanClaim,
    c.server_can_claim,
    ...bodies.flatMap(proofFlagValues)
  ]
  if ([...proofFlags, ...aliasProofFlags].some(isNegativeFlag)) return false
  if ([c, ...bodies].flatMap(rewardProofCandidateValues).some(isUnsafeProofMarkerValue)) return false
  const rewardDomainProofValues = [
    c.rewardProof,
    c.reward_proof,
    c.rewardIssueProof,
    c.reward_issue_proof,
    ...concreteRewardAliasProofValues(c),
    ...bodies.flatMap(body => [
      body.rewardProof,
      body.reward_proof,
      body.rewardIssueProof,
      body.reward_issue_proof,
      ...concreteRewardAliasProofValues(body)
    ])
  ]
  if (hasPositiveProofFlag(rewardDomainProofFlags)) return true
  return hasSafeProofValue(rewardDomainProofValues) ||
    hasSafeProofValue([c, ...bodies].flatMap(rewardRecordProofValues))
}

function explicitRewardIssueProofValues(source) {
  if (!source || typeof source !== 'object') return []
  return [
    source.rewardProof,
    source.reward_proof,
    source.rewardIssueProof,
    source.reward_issue_proof
  ]
}

export function hasExplicitRewardIssueProof(res) {
  const c = responseContent(res)
  if (!hasResponseContent(c)) return false
  if (hasUnavailableMarker(res)) return false
  if (hasNonPositiveAffectedRowsInResponse(res)) return false
  const bodies = responseBodies(res)
  const proofValues = [c, ...bodies].flatMap(explicitRewardIssueProofValues)
  if (proofValues.some(isNegativeFlag)) return false
  return hasPositiveProofFlag(proofValues) || hasSafeProofValue(proofValues)
}

export function hasRouletteResult(content) {
  const c = content || {}
  return hasRewardContent(c)
}

export function hasClaimFailure(content) {
  const c = content || {}
  if (hasUnavailableMarker(c)) return true
  if (hasNonPositiveAffectedRows(c)) return true
  if (isActiveGuardFlag(c.failed)) return true
  if ([
    c.rewardWritable,
    c.writable,
    c.writeEnabled
  ].some(value => isNegativeFlag(value))) return true
  return [
    c.receiveSuccess,
    c.claimSuccess,
    c.signSuccess,
    c.paySuccess,
    c.success,
    c.received,
    c.claimed,
    c.receiveStatus,
    c.claimStatus,
    c.status,
    c.state,
    c.promoStatus
  ].some(value => isNegativeFlag(value))
}

export function isClaimSuccess(res, customSuccess) {
  const c = responseContent(res)
  if (hasUnavailableMarker(res) || hasNonPositiveAffectedRowsInResponse(res) || !isOkResponse(res) || !hasResponseContent(c)) return false
  if (hasClaimFailure(c)) return false
  if (!hasRewardContent(c)) return false
  const customExplicitSuccess = typeof customSuccess === 'function' && customSuccess(c) === true
  const explicitSuccess = [
    c.receiveSuccess,
    c.claimSuccess,
    c.signSuccess,
    c.paySuccess,
    c.success,
    c.received,
    c.claimed,
    c.signed
  ].some(value => isPositiveFlag(value))
  return explicitSuccess ||
    customExplicitSuccess ||
    Number(c.receiveStatus) === 2 ||
    Number(c.claimStatus) === 2
}

export function isRewardClaimSuccessWithProof(res, customSuccess) {
  return isClaimSuccess(res, customSuccess) && hasRewardIssueProof(res)
}

export function isSafeRewardSuccess(res, customSuccess) {
  return isRewardClaimSuccessWithProof(res, customSuccess)
}

export function isRouletteSuccess(res) {
  const c = responseContent(res)
  if (hasUnavailableMarker(res) || hasNonPositiveAffectedRowsInResponse(res) || !isOkResponse(res) || !hasResponseContent(c)) return false
  if (hasClaimFailure(c)) return false
  return hasRouletteResult(c)
}

export function toArray(value) {
  if (Array.isArray(value)) return value
  if (!value || typeof value !== 'string') return []
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch (e) {
    return []
  }
}
